import logo from '../../assets/owlbot_logo_login.png';
import Popover from '@mui/material/Popover';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { colors } from '../../config/constants';
import { StateProps } from '../../redux/reducer';
import { useDispatch, useSelector } from 'react-redux';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import {
  initializeStore,
  responsiveSidebarChange,
  updateFlashBar,
  updateIsLoading,
} from '../../redux/action';
import ResponsiveSidebarNew from '../ResponsiveSidebar/ResponsiveSidebarNew';
import { errorMessage } from '../../config/errorsMsg';

const profileData = [
  {
    name: 'Profile',
    url: '/profile',
    icon: <i className="fa-solid fa-circle-user mr-2 text-md"></i>,
  },
  {
    name: 'Logout',
    url: '/logout',
    icon: <i className="fa-solid fa-right-from-bracket mr-2 text-md"></i>,
  },
];
const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const { firstName, lastName } = userInfo;
  const [profileanchorEl, setProfileAnchorEl] = useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setProfileAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setProfileAnchorEl(null);
  };

  const openprofile = Boolean(profileanchorEl);
  const id_profile = openprofile ? 'simple-popover' : undefined;

  const onClickProfile = (url: string) => {
    if (url === '/profile') {
      navigate(url);
    }
    if (url === '/logout') {
      handleLogOut();
    }
    handleClose();
  };

  const handleLogOut = async () => {
    dispatch(updateIsLoading(true));
    instance
      .post(`/auth/logout`, null, {
        withCredentials: true,
      })
      .then(async (response) => {
        if (response.status === 200) {
          await dispatch(initializeStore());
          navigate('/');
          dispatch(updateIsLoading(false));
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };
  return (
    <>
      <div
        className={`h-16 w-full flex items-center justify-between shadow-sm ${colors.primary} text-[white] z-10`}
      >
        <div className="flex items-center justify-between sm:justify-start cursor-pointer ">
          <div className="flex items-center">
            <div
              className="sm:hidden"
              onClick={() => dispatch(responsiveSidebarChange(true))}
            >
              <i className="fa-solid fa-bars p-1 text-[22px] ml-2"></i>
            </div>

            <div className="sm:w-[11rem] ml-2 bg-white h-[50px] flex items-center justify-center rounded-md shadow-lg">
              <img src={logo} className="h-[35px] sm:mr-12 text-lg sm:ml-10" />
            </div>
          </div>
        </div>
        <div className="h-16 sm:w-96 flex items-center space-x-4 justify-end">
          <div>
            <button
              className={`w-full flex space-x-2 sm:items-center mr-4 justify-start `}
              onClick={handleClick}
            >
              <div>
                <div className="sm:flex hidden text-sm font-semibold uppercase">
                  {firstName.charAt(0)} {lastName.charAt(0)}
                </div>
              </div>
              <div>
                <i className="fa-solid fa-power-off text-[22px]"></i>
              </div>
            </button>{' '}
            <div>
              <Popover
                className="mt-[14px] mr-2 ml-0 cursor-pointer"
                id={id_profile}
                open={openprofile}
                anchorEl={profileanchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
              >
                <div className={`w-[180px] ${colors.primaryText}`}>
                  {profileData.map((item, index) => {
                    return (
                      <div
                        onClick={() => onClickProfile(item.url)}
                        key={index}
                        className={`flex items-center p-2 border-b-2 border-slate-100 hover:bg-[#526D82] hover:text-white`}
                      >
                        {item.icon}
                        <div className="text-sm">{item.name}</div>
                      </div>
                    );
                  })}
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </div>
      <ResponsiveSidebarNew />
    </>
  );
};

export default Header;
